module.exports = __webpack_public_path__ + "img/right-arrow-more-hover.0bd3d274.svg";